import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'MP',
  quote: '"Organicé todo el mes en una tarde. Nunca más llego a la cancha sin saber qué drill voy a dar."',
  name: 'Martín P.',
  city: 'Buenos Aires',
  role: 'Profesor de Tenis en Club Privado',
  color: 'bg-blue-600'
}, {
  initials: 'CG',
  quote: '"Mis alumnos de nivel inicial mejoraron su técnica de derecha desde la primera semana con el Tomo 3."',
  name: 'Claudia G.',
  city: 'Córdoba',
  role: 'Profesora de Tenis en Academia',
  color: 'bg-purple-600'
}, {
  initials: 'FR',
  quote: '"Antes tardaba una hora armando una clase. Ahora son 5 minutos y la clase tiene 10 veces más estructura."',
  name: 'Federico R.',
  city: 'Rosario',
  role: 'Profesor de Tenis Independiente',
  color: 'bg-clay-orange'
}];
export function HeroTestimonials() {
  return <section className="py-16 bg-offwhite" data-id="element-176">
      <div className="max-w-6xl mx-auto px-4" data-id="element-177">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-178">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          duration: 0.5
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-179">
              <div className="flex text-ball-yellow mb-4" data-id="element-180">
                {[...Array(5)].map((_, idx) => <StarIcon key={idx} size={16} fill="currentColor" className="text-yellow-400" data-id="element-181" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-182">{t.quote}</p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-183">
                <div className={`w-12 h-12 rounded-full ${t.color} text-white flex items-center justify-center font-display text-lg`} data-id="element-184">
                  {t.initials}
                </div>
                <div data-id="element-185">
                  <div className="font-bold text-charcoal" data-id="element-186">{t.name}</div>
                  <div className="text-xs text-gray-500" data-id="element-187">
                    {t.city} | {t.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}